"use client";
import { isBackdrop } from "./is-backdrop.js";
import { setProperty } from "./orchestrate.js";
import { chain } from "@ariakit/utils";
//#region src/dialog/utils/tree-cleanup.ts
function getPropertyName(id = "", kind = "outside") {
	return `__ariakit-dialog-${kind}${id ? `-${id}` : ""}`;
}
function markElement(element, id = "") {
	return chain(setProperty(element, getPropertyName(), true), setProperty(element, getPropertyName(id), true));
}
function markAncestor(element, id = "") {
	return chain(setProperty(element, getPropertyName("", "ancestor"), true), setProperty(element, getPropertyName(id, "ancestor"), true));
}
function markTreeInside(id, elements) {
	return chain(...elements.map((element) => {
		if (!element) return void 0;
		return setProperty(element, getPropertyName(id, "inside"), true);
	}));
}
function isElementInside(element, id) {
	const propertyName = getPropertyName(id, "inside");
	do {
		if (element[propertyName]) return true;
		if (!element.parentElement) return false;
		element = element.parentElement;
	} while (true);
}
function isElementMarked(element, id) {
	const ancestorProperty = getPropertyName(id, "ancestor");
	if (element[ancestorProperty]) return true;
	const elementProperty = getPropertyName(id);
	do {
		if (element[elementProperty]) return true;
		if (!element.parentElement) return false;
		element = element.parentElement;
	} while (true);
}
function addElementMarkCleanup({ cleanups, element, id, ids }) {
	if (isBackdrop(element, ...ids)) return;
	cleanups.push(markElement(element, id));
}
function addAncestorMarkCleanup({ cleanups, ancestor, element, id }) {
	if (element.hasAttribute("data-dialog") && element.id !== id) return;
	cleanups.push(markAncestor(ancestor, id));
}
function restoreCleanups(cleanups) {
	for (let index = cleanups.length - 1; index >= 0; index -= 1) cleanups[index]?.();
}
//#endregion
export { addAncestorMarkCleanup, addElementMarkCleanup, isElementInside, isElementMarked, markAncestor, markElement, markTreeInside, restoreCleanups };

//# sourceMappingURL=tree-cleanup.js.map